/* Central catalog for every sidebar item. The backend only stores keys
 * (plus layout order + per-role visibility); this file owns the route,
 * icon, label, badge name, and testid so new tools can ship with just a
 * frontend deploy. Keep in sync with KNOWN_ITEMS in
 * `/app/backend/routes_nav_layout.py` — a key missing on either side is
 * ignored (safe) but won't appear in the sidebar.
 */
import {
    LayoutDashboard,
    Inbox,
    Users,
    FileText,
    ClipboardList,
    ListTodo,
    BookOpen,
    ShieldCheck,
    Calculator,
    Banknote,
    Receipt,
    Settings,
    Link2,
    Cloud,
    Send,
    AlertTriangle,
    Activity,
    GalleryHorizontalEnd,
    Sunrise,
    Wallet,
    Sparkles,
    CalendarClock,
    DollarSign,
    Home,
} from "lucide-react";

export const ITEM_CATALOG = {
    "dashboard":        { to: "/app",                   end: true, label: "Dashboard",            icon: LayoutDashboard },
    "morning-brief":    { to: "/app/morning-brief",                label: "Morning brief",        icon: Sunrise },
    "work-queue":       { to: "/app/work-queue",                   label: "Work queue",           icon: Activity,             badge: "open_work_count" },
    "inbox":            { to: "/app/inbox",                        label: "Inbox",                icon: Inbox },
    "clients":          { to: "/app/clients",                      label: "Clients",              icon: Users },
    "enrolments":       { to: "/app/enrolments",                   label: "Enrolments",           icon: Sparkles },
    "pipeline":         { to: "/app/pipeline",                     label: "Pipeline",             icon: Receipt },
    "family-cfo":       { to: "/app/family-cfo",                   label: "Family CFO",           icon: Wallet },
    "jobs":             { to: "/app/jobs",                         label: "Jobs",                 icon: ClipboardList },
    "production-line":  { to: "/app/production-line",              label: "Production line",      icon: GalleryHorizontalEnd },
    "requests":         { to: "/app/requests",                     label: "Requests",             icon: ClipboardList },
    "tasks":            { to: "/app/tasks",                        label: "Tasks",                icon: ListTodo },
    "tax-calendar":     { to: "/app/tax-calendar",                 label: "Tax calendar",         icon: CalendarClock },
    "exception-queue":  { to: "/app/exception-queue",              label: "Exception queue",      icon: AlertTriangle },
    "provisional-tax":  { to: "/app/provisional-tax",              label: "Provisional tax",      icon: Calculator },
    "audit-readiness":  { to: "/app/audit-readiness",              label: "Audit readiness",      icon: ShieldCheck },
    "tax-returns":      { to: "/app/tax-returns",                  label: "Tax returns",          icon: Banknote },
    "tax-liability":    { to: "/app/tax-liability",                label: "Tax Liability (legacy)", icon: Calculator },
    "tax-position":     { to: "/app/tax-position",                 label: "Tax Position Centre", icon: ShieldCheck },
    "tax-check-queue":  { to: "/app/tax-position/check-queue",     label: "IRD Check Queue",    icon: AlertTriangle,        badge: "tax_check_count" },
    "gst-monitor":      { to: "/app/gst-monitor",                  label: "GST Monitor",         icon: CalendarClock },
    "tax-provisioning": { to: "/app/tax-provisioning",             label: "Tax Provisioning",     icon: Calculator },
    "unmatched":        { to: "/app/unmatched",                    label: "Unmatched docs",       icon: AlertTriangle,        badge: "unmatched_count" },
    "audit":            { to: "/app/audit",                        label: "Review Readiness",     icon: ShieldCheck },
    "documents":        { to: "/app/documents",                    label: "Documents",            icon: FileText },
    "cash-register":    { to: "/app/cash-register",                label: "Cash register",        icon: Wallet },
    "integrations":     { to: "/app/integrations",                 label: "Integrations",         icon: Link2 },
    "sharepoint":       { to: "/app/sharepoint",                   label: "SharePoint sync",      icon: Cloud },
    "invites":          { to: "/app/invites",                      label: "Portal invites",       icon: Send },
    "help":             { to: "/app/help",                         label: "Help Centre",          icon: BookOpen },
    "settings":         { to: "/app/settings",                     label: "Settings",             icon: Settings },
    "wage-calculator":  { to: "/app/wage-calculator",              label: "Wage Calculator",      icon: DollarSign },
    "wage-reports":     { to: "/app/wage-reports",                 label: "Wage Reports",         icon: FileText },
    "email-center":     { to: "/app/email-center",                 label: "Email Center",         icon: Send },
    "rental-reminders": { to: "/app/rental-reminders",              label: "Rental Reminders",    icon: Home },
    "job-flow":         { to: "/app/job-flow",                     label: "Job Flow",             icon: Activity },
};

/** Fallback layout used only until the API responds (prevents the first
 *  paint from showing an empty sidebar). Mirrors the backend default. */
export const FALLBACK_LAYOUT = {
    role: "firm_admin",
    version: 0,
    groups: [
        { key: "overview",   label: "Overview",         items: ["dashboard"], roles_visible: ["firm_admin", "firm_staff"] },
        { key: "daily-work", label: "Daily work",       items: ["morning-brief", "work-queue", "inbox", "clients", "jobs", "production-line", "requests", "tasks", "email-center", "rental-reminders"], roles_visible: ["firm_admin", "firm_staff"] },
        { key: "tax",        label: "Tax",              items: ["tax-calendar", "exception-queue", "provisional-tax", "tax-returns", "tax-position", "tax-check-queue", "gst-monitor", "tax-liability", "unmatched"], roles_visible: ["firm_admin", "firm_staff"] },
        { key: "docs",       label: "Documents & data", items: ["documents", "cash-register"], roles_visible: ["firm_admin", "firm_staff"] },
    ],
};

export const KNOWN_ITEM_KEYS = Object.keys(ITEM_CATALOG);
